export default __webpack_public_path__ + "static/media/youtube_logo.a676ea31.png";